import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/TeaserDeck/TeaserDeck.css';

export const prototypeName = 'xk4bw2revXFJzx52v963uX699w7oGvF4bNVN4ZvAIKRdOL8L43U2JXJNdWnJfQaj2dOv51UMNqd1P';
export {styles};